export default "__VITE_ASSET__DQD2CfE5__"